export default "__VITE_ASSET__CBpad8CH__"